<template>
  <el-dialog
    :title="$t('text.product_characterisation')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="620px"
    @close="closeDialog()"
  >
    <div>
      <div class="mb-20">
        <span>{{ product.productNumber }} ({{ product.productName }})</span>
      </div>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-row>
          <el-col :span="24">
            <div class="desc-wrapper">
              <div class="desc-info">
                {{ $t('text.details') | firstLetterCapitalize }}
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="12" :xs="24">
            <el-form-item :label="$t('text.position')" prop="position">
              <el-select v-model="form.position">
                <el-option
                  v-for="item in positionOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :sm="12" :xs="24">
            <el-form-item :label="$t('text.constant') + ' B'" prop="constantB">
              <el-input-number
                v-model="form.constantB"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item :label="$t('text.constant') + ' C'" prop="constantC">
              <el-input-number
                v-model="form.constantC"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item :label="$t('text.constant') + ' D'" prop="constantD">
              <el-input-number
                v-model="form.constantD"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="desc-wrapper">
              <div class="desc-info">
                {{ $t('text.thresholds') }}
              </div>
            </div>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item :label="$t('text.yellow')" prop="yellowThreshold">
              <el-input-number
                v-model="form.yellowThreshold"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item :label="$t('text.red')" prop="redThreshold">
              <el-input-number
                v-model="form.redThreshold"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Max Sensor" prop="constantA">
              <el-input-number
                v-model="form.constantA"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="desc-wrapper">
              <div class="desc-info">
                {{ $t('text.urine_details') }}
              </div>
            </div>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item
              :label="$t('text.constant') + ' A'"
              prop="urineConstantA"
            >
              <el-input-number
                v-model="form.urineConstantA"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item
              :label="$t('text.constant') + ' B'"
              prop="urineConstantB"
            >
              <el-input-number
                v-model="form.urineConstantB"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item
              :label="$t('text.constant') + ' C'"
              prop="urineConstantC"
            >
              <el-input-number
                v-model="form.urineConstantC"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item
              :label="$t('text.constant') + ' D'"
              prop="urineConstantD"
            >
              <el-input-number
                v-model="form.urineConstantD"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="desc-wrapper">
              <div class="desc-info">
                {{ $t('text.urine_thresholds') }}
              </div>
            </div>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item
              :label="$t('text.yellow')"
              prop="urineYellowThreshold"
            >
              <el-input-number
                v-model="form.urineYellowThreshold"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item :label="$t('text.red')" prop="urineRedThreshold">
              <el-input-number
                v-model="form.urineRedThreshold"
                controls-position="right"
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="desc-wrapper">
              <div class="desc-info">
                {{ $t('text.other') | firstLetterCapitalize }}
              </div>
            </div>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Firmware Ver" prop="fwVersion">
              <el-input v-model="form.fwVersion"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item label="Hardware Ver" prop="hwVersion">
              <el-input v-model="form.hwVersion"></el-input>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item
              label="Max Capacity (Integer)"
              prop="maxCapacity"
              class="two-lines-label"
            >
              <el-input-number
                v-model="form.maxCapacity"
                controls-position="right"
                :step="1"
                step-strictly
              ></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :sm="12" :xs="24">
            <el-form-item
              label="Clumping Multiplier"
              prop="clumpingMultiplier"
              class="two-lines-label"
            >
              <el-input-number
                v-model="form.clumpingMultiplier"
                controls-position="right"
                :step="0.01"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="save-btn min-w-80" @click="save()" :loading="loading">{{
        $t('text.save').toUpperCase()
      }}</el-button>
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import ApiService from '@/services/CommonApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      dialogVisible: false,
      loading: false,
      form: {
        id: 0,
        position: '',
        constantA: '',
        constantB: '',
        constantC: '',
        constantD: '',
        yellowThreshold: '',
        redThreshold: '',
        urineConstantA: '',
        urineConstantB: '',
        urineConstantC: '',
        urineConstantD: '',
        urineRedThreshold: '',
        urineYellowThreshold: '',
        fwVersion: '',
        hwVersion: '',
        productID: this.$store.state.product.selectedProduct.id,
        maxCapacity: 1000,
        clumpingMultiplier: 0
      },
      product: '',
      rules: this.initRules(),
      positionOptions: []
    }
  },
  mounted() {
    this.getPositions()
  },
  watch: {
    '$store.state.locale.currentLocale': function() {
      this.rules = this.initRules()
    },
    'form.productID': function() {
      if (this.form.productID) {
        this.getProductDetail()
      }
    },
    '$store.state.product.selectedProduct': function() {
      this.form.productID = this.$store.state.product.selectedProduct.id
    }
  },
  methods: {
    initRules() {
      return {
        position: [
          {
            required: true,
            message: this.$t('text.position_required'),
            trigger: 'change'
          }
        ],
        constantA: [
          {
            required: true,
            message: 'Max Sensor is required'
          }
        ],
        constantB: [
          {
            required: true,
            message: this.$t('text.constant_b_required')
          }
        ],
        constantC: [
          {
            required: true,
            message: this.$t('text.constant_c_required')
          }
        ],
        constantD: [
          {
            required: true,
            message: this.$t('text.constant_d_required')
          }
        ],
        yellowThreshold: [
          {
            required: true,
            message: this.$t('text.yellow_threshold_required')
          }
        ],
        redThreshold: [
          {
            required: true,
            message: this.$t('text.red_threshold_required')
          }
        ],
        urineConstantA: [
          {
            required: true,
            message: this.$t('text.constant_a_required')
          }
        ],
        urineConstantB: [
          {
            required: true,
            message: this.$t('text.constant_b_required')
          }
        ],
        urineConstantC: [
          {
            required: true,
            message: this.$t('text.constant_c_required')
          }
        ],
        urineConstantD: [
          {
            required: true,
            message: this.$t('text.constant_d_required')
          }
        ],
        urineYellowThreshold: [
          {
            required: true,
            message: this.$t('text.yellow_threshold_required')
          }
        ],
        urineRedThreshold: [
          {
            required: true,
            message: this.$t('text.red_threshold_required')
          }
        ],
        fwVersion: [
          {
            required: true,
            message: this.$t('text.firmware_version_required')
          }
        ],
        hwVersion: [
          {
            required: true,
            message: this.$t('text.hardware_version_required')
          }
        ],
        maxCapacity: [
          {
            required: true,
            message: this.$t('text.max_capacity_required')
          }
        ],
        clumpingMultiplier: [
          {
            required: true,
            message: 'Clumping Multiplier is required'
          }
        ]
      }
    },
    openDialog() {
      this.dialogVisible = true
      this.getProductDetail()
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
    closeDialog() {
      this.resetForm()
      this.dialogVisible = false
    },
    getPositions() {
      ApiService.GetPosition()
        .then(response => {
          let vm = this
          for (let key in response.data.data) {
            vm.positionOptions.push({
              value: response.data.data[key],
              label: key
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    getProductDetail() {
      ApiService.GetProductDetailById(this.form.productID).then(response => {
        this.product = response.data.data
      })
    },
    getParams() {
      return {
        ID: this.form.id,
        ConstantA: this.form.constantA,
        ConstantB: this.form.constantB,
        ConstantC: this.form.constantC,
        ConstantD: this.form.constantD,
        FWVersion: this.form.fwVersion,
        HWVersion: this.form.hwVersion,
        MaxCapacity: this.form.maxCapacity,
        ClumpingMultiplier: this.form.clumpingMultiplier,
        Position: this.form.position,
        ProductID: this.form.productID,
        RedThreshold: this.form.redThreshold,
        UrineConstantA: this.form.urineConstantA,
        UrineConstantB: this.form.urineConstantB,
        UrineConstantC: this.form.urineConstantC,
        UrineConstantD: this.form.urineConstantD,
        UrineRedThreshold: this.form.urineRedThreshold,
        UrineYellowThreshold: this.form.urineYellowThreshold,
        YellowThreshold: this.form.yellowThreshold
      }
    },
    save() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          ApiService.AddorUpdateProductThreshold(this.getParams())
            .then(response => {
              this.loading = false
              if (response.data.success) {
                swal({
                  icon: 'success',
                  timer: 2000,
                  title: this.$t('text.saved_successfully')
                })
                this.$parent.getHwVersions(false)
                this.$parent.getFwVersions(false)
                this.$parent.getData()
                this.closeDialog()
              } else {
                swal({
                  icon: 'error',
                  title: this.$t('text.failed'),
                  text: response.data.msg
                })
              }
            })
            .catch(() => {
              this.loading = false
              swal({
                icon: 'error',
                timer: 2000,
                title: this.$t('text.failed')
              })
            })
        }
      })
    },
    resetForm() {
      this.form = {
        id: 0,
        position: '',
        constantA: '',
        constantB: '',
        constantC: '',
        constantD: '',
        yellowThreshold: '',
        redThreshold: '',
        urineConstantA: '',
        urineConstantB: '',
        urineConstantC: '',
        urineConstantD: '',
        urineRedThreshold: '',
        urineYellowThreshold: '',
        fwVersion: '',
        hwVersion: '',
        productID: this.$store.state.product.selectedProduct.id,
        maxCapacity: 1000,
        clumpingMultiplier: 0
      }
      this.$refs['form'].resetFields()
    }
  }
}
</script>
